import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@cmde/shadcn";
import { NetworkIcon, RotateCwIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ErrorCredentialsList({
  retry,
  errorMessage,
}: {
  retry: () => void;
  errorMessage?: string;
}) {
  const { t } = useTranslation();

  return (
    <Empty className="border border-solid bg-white/30">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <NetworkIcon />
        </EmptyMedia>
        <EmptyTitle>{t("credentials.list.general.error_fetching_credentials")}</EmptyTitle>
        <EmptyDescription>
          {errorMessage ?? t("credentials.list.general.error_description")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button onClick={retry}>
          <RotateCwIcon />
          {t("credentials.list.general.retry")}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
